import {
  groupInput,
  input,
  InputProvider,
  nonEmptyValidator,
} from "@redotech/ui/form";
import { memo } from "react";
import { RedoTextInput } from "../../../../arbiter-components/input/redo-text-input";

export const SpeeDeeCarrierInput = groupInput({
  accountNumber: input<string>({ validator: nonEmptyValidator }),
});

export type SpeeDeeCarrierValue = InputProvider.Value<
  typeof SpeeDeeCarrierInput
>;

export type SpeeDeeCarrierForm = InputProvider.Form<typeof SpeeDeeCarrierInput>;

export const SpeeDeeCarrierDefault = (): SpeeDeeCarrierValue => ({
  accountNumber: "",
});

export const CreateSpeeDeeCarrierForm = memo(function CreateSpeeDeeCarrierForm({
  carrierInput,
}: {
  carrierInput: SpeeDeeCarrierForm;
}) {
  return (
    <RedoTextInput
      label="Account number"
      placeholder=""
      setValue={carrierInput.inputs.accountNumber.setValue}
      value={carrierInput.inputs.accountNumber.value}
    />
  );
});
